import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import { i18n } from './i18n'
import VueAnalytics from 'vue-analytics'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

import BootstrapVue from 'bootstrap-vue'
import VueClipboard from 'vue-clipboard2'

const fb = require('./firebaseConfig')

library.add(fas, far, fab)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

dom.watch()

Vue.use(BootstrapVue)
Vue.use(VueClipboard)
Vue.use(VueAnalytics, {
  id: window.location.host.includes('waxdetective') ? 'UA-131263929-2' : 'UA-131263929-1',
  router
})

document.title = window.location.host.includes('waxdetective') ? 'WAX Detective - Forensic Data Analysis' : 'EOS Detective - Forensic Data Analysis'

Vue.config.productionTip = false

let app = ''

fb.auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount('#app')
  }
})
